<form  id="authorization-form-pg" [formGroup]="formGroup">
    <!-- Code Implementation for Contact Information class="flex flex-col gap-4" -->

    <p-panel styleClass="border-0 panel-dotted-heading">
    <div formArrayName="authorizations">
        <div *ngFor="let authorization of authorizations.controls; let i = index" [formGroupName]="i" [ngClass]="{'mt-5': i > 0}">
            <div class="row mb-3">
                <div class="col-sm-12">
                    <div class="border-bottom-dotted d-flex justify-content-between align-items-center">
                        <h2 class="contactListNo">
                            <span *ngIf="i<9">Opposing Counsel {{ '0'+ (i + 1) }}</span>
                            <span *ngIf="i>=9">Opposing Counsel {{ i + 1 }}</span>
                        </h2>
                        <p-button icon="pi pi-trash" styleClass="p-0 mb-1" [link]="true" [text]="true"
                            aria-label="Delete" label="Delete" *ngIf="authorizations && authorizations.length > 1"
                            (onClick)="removeAuthorization(i)"></p-button>
                    </div>
                    <!--  <hr /> -->
                </div>
            </div>
            <div class="row mb-0 mb-lg-3">
                <div class="col-sm-3 mb-3 mb-sm-0">
                    <label for="authorization-record-subject-name-{{i}}" class="form-label d-block required-asterisk">Record Subject Name</label>
                    <!-- <p-dropdown [options]="subjectNames"  formControlName="recordSubjectName" styleClass="w-100" 
                    id="record-subject-name-{{i}}" placeholder="Select record subject name" [ngClass]="{'ng-invalid ng-dirty' : isError('recordSubjectName', authorization)}" /> -->

                    <p-multiselect [options]="subjectNames" [showToggleAll]="false" [filter]="false" display="chip" id="authorization-record-subject-name-{{i}}" styleClass="w-100" formControlName="recordSubjectName" optionLabel="name" placeholder="Select record subject name" [ngClass]="{'ng-invalid ng-dirty' : isError('recordSubjectName', authorization)}" />

                    <small id="order-info-ref-num-error" *ngIf="isError('recordSubjectName', authorization)" class="error-label">This field is mandatory</small>
                </div>
                <div class="col-sm-3 mb-3 mb-sm-0">
                    <label for="authorization-opposing-counsel-attorney-name-{{i}}"
                        class="form-label d-block required-asterisk">Opposing Counsel Attorney Name</label>
                    <input pInputText type="text" id="authorization-opposing-counsel-attorney-name-{{i}}" class="w-100"
                        placeholder="Enter opposing counsel attorney name"
                        formControlName="opposingCounselAttorneyName" [ngClass]="{'ng-invalid ng-dirty' : isError('opposingCounselAttorneyName', authorization)}" />
                        <small id="order-info-ref-num-error" *ngIf="isError('opposingCounselAttorneyName', authorization)" class="error-label">This field is mandatory</small>
                </div>
                <div class="col-sm-3 mb-3 mb-sm-0">
                    <label for="authorization-opposing-counsel-firm-name-{{i}}" class="form-label d-block required-asterisk">Opposing Counsel Firm Name</label>
                    <input pInputText type="text" id="authorization-opposing-counsel-firm-name-{{i}}" class="w-100"
                        placeholder="Enter opposing counsel firm name" formControlName="opposingCounselFirmName" [ngClass]="{'ng-invalid ng-dirty' : isError('opposingCounselFirmName', authorization)}" />
                        <small id="order-info-ref-num-error" *ngIf="isError('opposingCounselFirmName', authorization)" class="error-label">This field is mandatory</small>
                </div>
            </div>
            <div class="row mb-0 mb-lg-3">
                <div class="col-sm-3 mb-3 mb-sm-0">
                    <label for="authorization-street-address-{{i}}" class="form-label d-block">Street Address</label>
                    <input pInputText type="text" id="street-address-{{i}}" class="w-100"
                        placeholder="Enter street address" formControlName="streetAddress" />
                </div>
                <div class="col-sm-3 mb-3 mb-sm-0">
                    <label for="authorization-city-{{i}}" class="form-label d-block">City</label>
                    <input pInputText type="text" id="authorization-city-{{i}}" class="w-100" placeholder="Enter city"
                        formControlName="city" />
                </div>
                <div class="col-sm-3 mb-3 mb-sm-0">
                    <label for="authorization-state-{{i}}" class="form-label d-block">State</label>
                    <p-select formControlName="state" id="authorization-state-{{i}}" [options]="states" optionLabel="name"
                        placeholder="Select state" styleClass="w-100" />
                </div>
                <div class="col-sm-3 mb-3 mb-sm-0">
                    <label for="authorization-zip-{{i}}" class="form-label d-block">Zip</label>
                    <input pInputText type="text" id="authorization-zip-{{i}}" class="w-100" placeholder="Enter zip"
                        formControlName="zip" />
                </div>
            </div>
            <div class="row mb-0 mb-lg-3">
                <div class="col-8 col-md-2 col-lg-2 mb-3 mb-sm-0 pe-1">
                    <label for="authorization-phone-{{i}}" class="form-label d-block">Phone</label>
                    <input pInputText type="text" id="authorization-phone-{{i}}" class="w-100" placeholder="Enter phone"
                        formControlName="phone" />
                </div>
                <div class="col-4 col-md-1 col-lg-1 mb-3 mb-sm-0 ps-1">
                    <label for="authorization-phone-extn-{{i}}"
                        class="form-label d-block">Extension</label>
                    <input pInputText type="number" id="authorization-phone-extn-{{i}}" placeholder="Enter"
                        formControlName="extn" class="w-100" />
                </div>
                <div class="col-sm-3 mb-3 mb-sm-0">
                    <label for="authorization-fax-{{i}}" class="form-label d-block">Fax</label>
                    <input pInputText type="text" id="authorization-fax-{{i}}" class="w-100" placeholder="Enter fax"
                        formControlName="fax" />
                </div>
                <div class="col-sm-3 mb-3 mb-sm-0">
                    <label for="authorization-email-{{i}}" class="form-label d-block">Email</label>
                    <input pInputText type="email" id="authorization-email-{{i}}" class="w-100"
                        placeholder="Enter email" formControlName="email" />
                    <small *ngIf="authorization?.get('email')?.hasError('email')" class="error-label">Please
                        enter a valid email address.</small>
                </div>
            </div>
        </div>
    </div>
    <p-button label="Add Opposing Counsel" styleClass="px-0" icon="pi pi-plus" (onClick)="addAuthorization()" [link]="true" />
    <div class="row mb-3">
        <div class="col-sm-3 mb-3 mb-sm-0">
            <label for="authorization-case-number" class="form-label d-block">Case Number </label>
            <input pInputText type="text" id="authorization-case-number" class="w-100" placeholder="Enter case number"
            formControlName="caseNumber" />
        </div>
    </div>
    </p-panel>
</form>
<app-modal [header]="'Delete Confirmation'" [(showDialog)]="showDeleteModal" [rejectLabel]="'No'" [acceptLabel]="'Yes'" (acceptModalClick)="delete()" (rejectModalClick)="showDeleteModal = false">
    <span>Are you sure want to delete this?</span>
